module.exports = __webpack_public_path__ + "img/podragu.611f985a.jpg";